import { ReactComponent as CopyIcon } from '../../../../../images/icons/copy.svg';
import { Button } from '@mui/material';

export const CopyJsonButton = ({
  context,
  text = 'Copy JSON',
  title = 'Copy all context data'
}) => {
  const copyJsonToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(context, null, 2));
    } catch (err) {
      // eslint-disable-next-line
      console.error('Failed to copy text: ', err);
    }
  };

  const hasContextKeys =
    context && typeof context === 'object' && Object.keys(context).length;

  // calculate size in KB
  const contextSize = hasContextKeys
    ? new Blob([JSON.stringify(context)]).size / 1024
    : 0;

  // format size with 2 decimal places
  const formattedSize =
    contextSize > 1024
      ? `${(contextSize / 1024).toFixed(2)} MB`
      : `${contextSize.toFixed(2)} KB`;

  return (
    hasContextKeys && (
      <Button
        size='small'
        variant='outlined'
        onClick={copyJsonToClipboard}
        title={title}
        startIcon={<CopyIcon />}
      >
        {text} ({formattedSize})
      </Button>
    )
  );
};

export default CopyJsonButton;
